import React from "react";
import PdfLayout from '../PdfLayout';
import PdfLayoutWidget from './PdfLayoutWidget';
import { Screen } from '../../services';
import { buildDocumentBodyPreviewLines } from '../../services/pdfLayoutPreviewSample';
import { canonical_pdf_layout_type } from '../../services/pdfLayoutType';

/**
 * Catch-all content widget for multipage PDFs (receipt, closing, bookings).
 *
 * The reserved box is filled by the engine with flowing content; when it
 * overflows, the engine clones the continuation page template.
 */
class DocumentBodyWidget extends PdfLayoutWidget {

    constructor(properties) {
        super({
            ...(DocumentBodyWidget.getDefaultOptions()),
            ...properties,
        });

        this.type    = PdfLayout.TEXT;
        this.subType = PdfLayout.DOCUMENT_BODY;
    }

    static getDefaultOptions() {
        return {
            position: { x: 1.5, y: 4, z: 0 },
            dimensions: { width: 18, height: 18 },
            transform: { rotation: 0 },
            options: {
                style: {
                    color: '#000000',
                    fontFamily: 'Helvetica',
                    fontSize: 10,
                    lineHeight: 1.2,
                    textAlign: 'left',
                    backgroundColor: '#FFFFFF00',
                    borderStyle: 'dashed',
                    borderWidth: 1,
                    borderColor: '#999999',
                    borderRadius: 0,
                    padding: {
                        top: 0.1,
                        right: 0.1,
                        bottom: 0.1,
                        left: 0.1,
                    },
                },
            },
        };
    }

    getHandledOptions() {
        return [
            PdfLayout.OPTION_X,
            PdfLayout.OPTION_Y,
            PdfLayout.OPTION_Z,
            PdfLayout.OPTION_WIDTH,
            PdfLayout.OPTION_HEIGHT,
            PdfLayout.OPTION_COLOR,
            PdfLayout.OPTION_FONT_FAMILY,
            PdfLayout.OPTION_FONT_SIZE,
            PdfLayout.OPTION_LINE_HEIGHT,
            PdfLayout.OPTION_TEXT_ALIGNMENT,
            PdfLayout.OPTION_PADDING,
            PdfLayout.OPTION_BACKGROUND_COLOR,
            PdfLayout.OPTION_BORDER_COLOR,
            PdfLayout.OPTION_BORDER_STYLE,
            PdfLayout.OPTION_BORDER_WIDTH,
            PdfLayout.OPTION_BORDER_RADIUS,
        ];
    }

    getIcon() {
        return 'list-alt';
    }

    getPreview(props) {
        const { lang, layout } = props;
        const layoutType = canonical_pdf_layout_type(layout?.type);
        const lines = buildDocumentBodyPreviewLines(layoutType, lang);
        const fallback = {
            fr: ['Corps du document (liste…)'],
            en: ['Document body (list…)'],
            de: ['Dokumentkörper (Liste…)'],
            it: ['Corpo documento (lista…)'],
        };
        const displayLines = lines.length
            ? lines
            : (fallback[lang] || fallback.en);

        return (
            <div style={{
                width: Screen.cmToPx(this.dimensions?.width),
                height: Screen.cmToPx(this.dimensions?.height),
                color: this.options?.style?.color || '#000000',
                fontSize: Screen.ppToPx(this.options?.style?.fontSize || 10),
                lineHeight: this.options?.style?.lineHeight || 1.2,
                textAlign: this.options?.style?.textAlign || 'left',
                backgroundColor: this.options?.style?.backgroundColor || 'transparent',
                border: `${this.options?.style?.borderWidth || 0}px ${this.options?.style?.borderStyle || 'solid'} ${this.options?.style?.borderColor || '#000'}`,
                borderRadius: `${this.options?.style?.borderRadius || 0}px`,
                paddingTop: `${Screen.cmToPx(this.options?.style?.padding?.top || 0)}px`,
                paddingRight: `${Screen.cmToPx(this.options?.style?.padding?.right || 0)}px`,
                paddingBottom: `${Screen.cmToPx(this.options?.style?.padding?.bottom || 0)}px`,
                paddingLeft: `${Screen.cmToPx(this.options?.style?.padding?.left || 0)}px`,
                overflow: 'hidden',
                boxSizing: 'border-box',
                whiteSpace: 'pre',
                fontFamily: this.options?.style?.fontFamily || 'Helvetica, monospace',
            }}>
                {displayLines.map((line, i) => (
                    <div key={i}>{line || '\u00a0'}</div>
                ))}
            </div>
        );
    }
}

export default DocumentBodyWidget;
